import { render, staticRenderFns } from "./PwaVouchers.vue?vue&type=template&id=79c20a84&scoped=true"
import script from "./PwaVouchers.vue?vue&type=script&lang=js"
export * from "./PwaVouchers.vue?vue&type=script&lang=js"
import style0 from "./PwaVouchers.vue?vue&type=style&index=0&id=79c20a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c20a84",
  null
  
)

export default component.exports